export default [
  {
    name: 'ROOT',
    value: '/'
  },
  {
    name: 'LOGIN',
    value: '/login'
  },
  {
    name: 'MAIN',
    value: '/main/:menuId'
  }
]